var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShopAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_shop-add",
    "data-name": "vuesax/bulk/shop-add",
    transform: "translate(-750 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shop-add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(750 188)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M18.74.28V6.27a5,5,0,0,1-5,5H5a5.061,5.061,0,0,1-.68-.05,3.661,3.661,0,0,0,1-.65.474.474,0,0,0,.1-.1,3.334,3.334,0,0,0,.69-.84,3.921,3.921,0,0,0,.58-2.06A4.011,4.011,0,0,0,5.62,4.85a2.423,2.423,0,0,0-.33-.31A3.963,3.963,0,0,0,.73,4.09a3.172,3.172,0,0,0-.54.36A1.537,1.537,0,0,0,0,4.62V.35A4.077,4.077,0,0,0,3.01,1.64,4.093,4.093,0,0,0,6.24,0,3.754,3.754,0,0,0,9.37,1.64,3.734,3.734,0,0,0,12.48.04a4.1,4.1,0,0,0,3.2,1.6A3.99,3.99,0,0,0,18.74.28Z",
    transform: "translate(752.31 199.43)",
    fill: "#292d32",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M6.757,0h-6L.017,7.36a3.888,3.888,0,0,0,.29,1.9,3.737,3.737,0,0,0,3.46,2.24,3.726,3.726,0,0,0,3.47-2.23,3.979,3.979,0,0,0,.3-1.44V7.64Z",
    transform: "translate(757.913 189.57)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M8.84,7.03,8.56,4.25C8.14,1.23,6.77,0,3.84,0H0L.74,7.5a3.591,3.591,0,0,1,.02.4,3.818,3.818,0,0,0,.46,1.43A4.146,4.146,0,0,0,4.8,11.5,3.982,3.982,0,0,0,8.08,9.87,4.076,4.076,0,0,0,8.84,7.03Z",
    transform: "translate(763.2 189.56)",
    fill: "#292d32",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M5.019,0C2.079,0,.719,1.23.289,4.28L.019,7.03a4.111,4.111,0,0,0,.82,2.92,4.01,4.01,0,0,0,3.23,1.55,4.139,4.139,0,0,0,3.57-2.15,3.722,3.722,0,0,0,.48-1.51L8.9.01H5.019Z",
    transform: "translate(751.251 189.57)",
    fill: "#292d32",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M6.93,1.28A2.423,2.423,0,0,0,6.6.97,3.963,3.963,0,0,0,2.04.52,3.172,3.172,0,0,0,1.5.88,3.97,3.97,0,0,0,0,4,3.921,3.921,0,0,0,.58,6.06a2.827,2.827,0,0,0,.32.45c.02.03.05.05.07.08A3.96,3.96,0,0,0,6.63,7a.474.474,0,0,0,.1-.1,3.334,3.334,0,0,0,.69-.84A3.921,3.921,0,0,0,8,4,4.011,4.011,0,0,0,6.93,1.28ZM5.5,4.73H4.75v.78a.75.75,0,0,1-1.5,0V4.73H2.5a.75.75,0,0,1,0-1.5h.75V2.52a.75.75,0,0,1,1.5,0v.71H5.5a.75.75,0,0,1,0,1.5Z",
    transform: "translate(751 203)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(750 188)",
    fill: "none",
    opacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopAdd);
export default __webpack_public_path__ + "static/media/shop-add.9ed73070dcb1e9486a2ac16188b8b92f.svg";
export { ForwardRef as ReactComponent };